import type { ComponentType } from "react";
import { AddNotePanel } from "./AddNotePanel";
import { SetStatusPanel } from "./SetStatusPanel";
import { AddCostPanel } from "./AddCostPanel";

export type ActivityPanelProps = {
  activityType: string;
  activityTitle: string;
  initialValues?: Record<string, unknown>;
  onSubmit: (runInput: Record<string, unknown>) => void;
  onCancel: () => void;
  submitting?: boolean;
};

export function getActivityPanel(activityType: string): ComponentType<ActivityPanelProps> | null {
  switch (activityType) {
    case "add_note":
      return function AddNotePanelWrap(props) {
        return (
          <AddNotePanel
            initialNote={typeof props.initialValues?.note === "string" ? props.initialValues.note : ""}
            onSubmit={(p) => props.onSubmit({ note: p.note })}
            onCancel={props.onCancel}
            submitting={props.submitting}
          />
        );
      };
    case "set_status":
      return function SetStatusPanelWrap(props) {
        return (
          <SetStatusPanel
            initialStatus={typeof props.initialValues?.status === "string" ? props.initialValues.status : "completed"}
            initialComment={typeof props.initialValues?.comment === "string" ? props.initialValues.comment : ""}
            onSubmit={(p) => props.onSubmit({ status: p.status, comment: p.comment })}
            onCancel={props.onCancel}
            submitting={props.submitting}
          />
        );
      };
    case "add_cost":
      return function AddCostPanelWrap(props) {
        return (
          <AddCostPanel
            onSubmit={(p) =>
              props.onSubmit({
                cost_type: p.cost_type,
                quantity: p.quantity,
                amount: p.amount,
                label: p.label,
              })
            }
            onCancel={props.onCancel}
            submitting={props.submitting}
          />
        );
      };
    default:
      return null;
  }
}
